export default __webpack_public_path__ + "static/media/exterior (16).9abb1fbc.jpg";